<template>
  <div v-if="invoice">
    <p class="text-base" v-if="!isAdmin">Account Email: {{currentUser.email ? currentUser.email : passed_email}}</p>

    <!--<h3>Entry Details</h3>-->
    <showman-table class="mt-4" :tableData="invoice.line_items" :tableFields="checkoutTableFields" :condensed="true">
      <div slot="amount" slot-scope="data">
        <div class="text-right" v-if="data.item.rate">
          <span v-if="data.item.late_fee">*</span><span class="text-xl font-thin">{{currencySymbol}}{{data.item.rate.toFixed(2)}}</span>
        </div>
        <div class="text-right" v-else>
          -
        </div>
      </div>
      <div slot="details" slot-scope="data">
        <div v-if="data.item.sub_rate" class="">
          <div v-for="(s, i) in data.item.sub_rate" :key="i" class="flex justify-start text-sm text-gray-700">
            <div>{{s.description}} - {{currencySymbol}}{{s.rate}}</div>
          </div>
        </div>
        <p v-if="data.item.created_at" class="text-xs mt-1">Created: {{Localized.formatDateFullYear(data.item.created_at, invoice.location_details.country)}}</p>
      </div>
      <div slot="description" slot-scope="data">
        <div class="font-medium"><span v-if="show_exhibitor_number">{{data.item.exhibitor_number}} - </span>{{data.item.exhibitor}}</div>
        <div class="text-sm">{{data.item.name}}</div>
      </div>
    </showman-table>
    <div class="text-sm" v-if="lateFeesApplied"><b>*Late Fee has been applied for this entry</b></div>
    <div class="hr"></div>
    <div class="w-full my-2 p-2 rounded bg-gray-200" v-if="(Object.keys(entryGroup).length !== 0 && entryGroup.constructor === Object) && !isAdmin">
      <p class="text-xl pb-1">Entry Questions Summary</p>
      <div v-for="(q, i) in event.entry_questions" :key="i" class="mb-2">
        <template v-if="!q.details.admin_only">
          <div class="text-xs font-bold">{{q.question}}</div>
          <div v-for="(option,k) in optionList(q)" :key="k">
            <div v-if="q.details.multi_answer && q.details.answer_type !== 'dropdown'">{{option.value}}:
              <span v-if="!q.details.exhibitor_question && entryGroup" class="text-sm">{{typeof entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}`] !== 'undefined' ? entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}`] : '(Not Answered)'}}</span>
            </div>
            <div v-for="(e,j) in exhibitorList(q)" :key="j" >
              <div v-if="q.details.exhibitor_question && entryGroup" class="text-sm">
                {{e.first_name}} {{e.last_name}} -
                {{typeof entryGroup.entry_questions[`${q.entry_question_id}${(q.details.multi_answer && q.details.answer_type !== 'dropdown') ? `:${option.id}` : ''}:${e.exhibitor_id}`] !== 'undefined' ? entryGroup.entry_questions[`${q.entry_question_id}${(q.details.multi_answer && q.details.answer_type !== 'dropdown') ? `:${option.id}` : ''}:${e.exhibitor_id}`] : '(Not Answered)'}}
              </div>
            </div>
            <p class="text-sm" v-if="entryGroup.entry_questions[q.entry_question_id]">{{entryGroup.entry_questions[q.entry_question_id]}}</p>
          </div>
        </template>
      </div>
    </div>

    <div class="flex justify-end text-xl text-right">
      <div>
        <div>Total for all Entries:</div>
        <div>
          Previous Payments:
          <div class="mb-2" v-if="invoice.previous_payments.length">
            <div v-for="(p,i) in invoice.previous_payments" :key="i" class="flex-col justify-end text-sm text-gray-800 font-medium border-b">
              <div>{{`${currencySymbol}${p.total_amount.toFixed(2)} on ${Localized.formatDateFullYear(p.date, invoice.location_details.country)}:`}}</div>
              <div>{{`${currencySymbol}${(p.amount).toFixed(2)}`}} - show entries</div>
              <div>{{`${currencySymbol}${(p.total_amount - p.amount).toFixed(2)}`}} - CC Fee</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mr-2 ml-3">
        <div v-if="invoice.invoice_total">{{currencySymbol}}{{invoice.invoice_total.toFixed(2)}}</div>
        <div>({{currencySymbol}}{{invoice.previvous_payment_totals.toFixed(2)}})</div>
      </div>

    </div>
    <div class="flex justify-end text-xl text-right mt-1">
      <div>
        <div v-if="invoice.amount_owed_show >= 0 && invoice.credit_card_fees" class="pt-1">Amount Owed Show (Subtotal):</div>
        <div v-else-if="invoice.amount_owed_show < 0" class="pt-1">Entry Credits Remaining:</div>
        <div v-if="showFees">
          <div v-if="invoice.platform_fee">Platform Fee:</div>
          <div v-if="invoice.credit_card_fees">Credit Card Fee:</div>
          <div class="font-bold mt-2">Total Due:</div>
        </div>
        <div v-else-if="invoice.amount_owed_show >= 0">
          <div class="font-bold mt-2">Total Due:</div>
        </div>
      </div>
      <div class="pr-2 pl-3">
        <div v-if="invoice.amount_owed_show >= 0 && invoice.credit_card_fees" class="border-t pt-1 border-black">{{currencySymbol}}{{invoice.amount_owed_show.toFixed(2)}}</div>
        <div v-else-if="invoice.amount_owed_show < 0" class="border-t pt-1 border-black">{{`($${Math.abs(invoice.amount_owed_show).toFixed(2)})`}}</div>
        <div v-if="showFees">
          <div v-if="invoice.platform_fee">{{currencySymbol}}{{invoice.platform_fee.toFixed(2)}}</div>
          <div v-if="invoice.credit_card_fees">{{currencySymbol}}{{invoice.credit_card_fees.toFixed(2)}}</div>
          <div class="border-t border-black mt-2"> {{currencySymbol}}{{invoice.total_amount_owed.toFixed(2)}}</div>
        </div>
        <div v-else-if="invoice.amount_owed_show >= 0">
          <div class="border-t border-black mt-2">{{currencySymbol}}{{invoice.amount_owed_show.toFixed(2)}}</div>
        </div>
      </div>
    </div>
    <div class="flex justify-end text-gray-800 text-center my-4" v-if="event.event_details"><strong v-if="event.event_details.refund_policy" class='mr-1'>Refund Policy: </strong> {{event.event_details.refund_policy}}</div>

  </div>
</template>

<script>

export default {
  props: {
    invoice: Object,
    show_exhibitor_number: {
      type: Boolean,
      default: false
    },
    showFees: {
      type: Boolean,
      deafault: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    passed_email: String
  },
  data () {
    return {
      checkoutTableFields: [
        {key: 'description', position: 'left'},
        {key: 'details', position: 'left'},
        {key: 'amount', position: 'right'}
      ]
    }
  },
  methods: {
    exhibitorList (q) {
      let list = []
      if (q.details.exhibitor_question) {
        return this.entryGroup.exhibitors
      } else {
        list = [1]
      }
      return list
    },
    optionList (q) {
      let list = [{
        value: 'SINGLE_ANSWER'
      }]
      if (q.details.multi_answer && q.details.answer_type !== 'dropdown') {
        return q.details.answer_options
      } else {
        return list
      }
    }
  },
  computed: {
    currentUser () {
      if (this.$store) {
        return this.$store.state.user ? this.$store.state.user : {}
      } else {
        return {}
      }
    },
    entryGroup () {
      if (this.$store) {
        return this.$store.state.entryGroup.currentEntryGroup
      } else {
        return {}
      }
    },
    lateFeesApplied () {
      let late = false
      this.invoice.line_items.forEach(l => {
        if (l.late_fee) {
          late = true
        }
      })
      return late
    },
    event () {
      if (this.$store) {
        if (this.isAdmin) {
          return this.$store.state.admin.adminData.event
        } else {
          return this.$store.state.event.currentEvent
        }
      } else {
        return {}
      }
    },
    currencySymbol () {
      return this.Localized.getCurrencyInfo(this.invoice.location_details.country).symbol
    }
  }
}
</script>

<style>

</style>
